module.exports = __webpack_public_path__ + "static/media/04.3f202495.mp3";